export default __webpack_public_path__ + "static/work-0ef7d84f6e77aac8cbc5b9c28509e564.png";